import { Role, ICurrentUser, IAssetTag } from '@api'
import { IPermissionsOnAsset } from './types'

export function onAsset(user: ICurrentUser, asset?: IAssetTag): IPermissionsOnAsset {
  const permissions = {
    canUpdate: true,
    canDelete: true,
    canCreate: true,
    canAddEmployees: true,
    canRemoveEmployees: true,
    canAddSpaces: true,
    canRemoveSpaces: true,
  }

  if (user.employee.role === Role.ADMIN || user.employee.role === Role.POWER_ADMIN)
    return permissions

  if (user.employee.role === Role.LOCATION_ADMIN)
    return {
      canCreate: true,
      canDelete: false,
      canUpdate: false,
      // requires BE validation
      canAddEmployees: true,
      canRemoveEmployees: true,
      canAddSpaces: true,
      canRemoveSpaces: true,
    }

  // all other roles (IT, Viewer, Dept. Admin, Space Captain)
  // have no apollo permissions to create, update, or delete
  // they also don't have access to asset mgmt in nav or in app
  return {
    canCreate: false,
    canDelete: false,
    canUpdate: false,
    canAddEmployees: false,
    canRemoveEmployees: false,
    canAddSpaces: false,
    canRemoveSpaces: false,
  }
}
